export default __webpack_public_path__ + "media/integrations/thunderbird-b53233f5.svg";